/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_TitleInputs */

const en_inbox_title = /** @type {(inputs: Inbox_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestions`)
};

const de_inbox_title = /** @type {(inputs: Inbox_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschläge`)
};

/**
* | output |
* | --- |
* | "Suggestions" |
*
* @param {Inbox_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const inbox_title = /** @type {((inputs?: Inbox_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_inbox_title(inputs)
	return en_inbox_title(inputs)
});